import { render, staticRenderFns } from "./MatchPairImageButton.vue?vue&type=template&id=58a7aff8&scoped=true"
import script from "./MatchPairImageButton.vue?vue&type=script&lang=js"
export * from "./MatchPairImageButton.vue?vue&type=script&lang=js"
import style0 from "./MatchPairImageButton.vue?vue&type=style&index=0&id=58a7aff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7aff8",
  null
  
)

export default component.exports